import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { recipes } from '../data/data';

const RecipeFoodCard = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const recipe = state || recipes.find(r => r.id === parseInt(id));

  if (!recipe) return <p style={{ padding: '2rem' }}>Recipe not found.</p>;

  const { title, description, image, prepTime, cookTime, category, difficulty } = recipe.foodRecipes;

  return (
    <div className="recipe-card">
      <div className="recipe-image">
        <img src={image} alt={title} />
        <div className="recipe-category">{category}</div>
      </div>
      <div className="recipe-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="recipe-meta">
          <div className="recipe-time">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>{prepTime + cookTime} mins</span>
          </div>
          <div className="recipe-difficulty">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20v-6M6 20V10M18 20V4"></path>
            </svg>
            <span>{difficulty || 'Medium'}</span>
          </div>
        </div>
      </div>

      <style jsx>{`
        .recipe-card {
          max-width: 800px;
          margin: 2rem auto;
          background-color: var(--white);
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .recipe-image {
          position: relative;
          height: 300px;
        }

        .recipe-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .recipe-category {
          position: absolute;
          top: 15px;
          right: 15px;
          background-color: var(--primary-color);
          color: white;
          padding: 5px 10px;
          border-radius: 20px;
          font-size: 0.8rem;
          text-transform: capitalize;
        }

        .recipe-content {
          padding: 1.5rem;
        }

        .recipe-content h3 {
          font-size: 1.8rem;
          margin-bottom: 0.7rem;
        }

        .recipe-content p {
          color: var(--gray);
          font-size: 1rem;
          margin-bottom: 1.2rem;
          line-height: 1.6;
        }

        .recipe-meta {
          display: flex;
          justify-content: space-between;
          font-size: 0.95rem;
          color: var(--gray);
        }

        .recipe-time, .recipe-difficulty {
          display: flex;
          align-items: center;
        }

        .recipe-time svg, .recipe-difficulty svg {
          margin-right: 5px;
          color: var(--primary-color);
        }
      `}</style>
    </div>
  );
};

export default RecipeFoodCard;
